function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "pressing_iron"
}, /*#__PURE__*/React.createElement("title", null, "190808_VF_Nina_App_Icons_RZ"), /*#__PURE__*/React.createElement("path", {
  d: "M228.4 63.7l-.3.1H42.3v28.3h164l16.3 64.9H81.4c-6.4 0-37.5 2-50.4 38.8L0 283.5h283.5L228.4 63.7zM40.3 254.9l17.5-49.7c3-8.5 7.4-14.1 13.5-17.1 3-1.5 6.2-2.3 9.5-2.6h148.7l17.4 69.4H40.3z"
}))));